import styled from 'styled-components'

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    width: 100%;
`

export const Title = styled.h1`
    font-size: 16px;
    font-weight: bold;
    color: #0b1f82;
    margin: 0;
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`

export const Description = styled.p`
    font-size: 14px;
    font-weight: normal;
    line-height: 140%;
    color: #383838;
    transition: all 0.3s ease;
    white-space: pre-wrap;
`

export const ErrorText = styled.p`
    font-size: 14px;
    font-weight: normal;
    line-height: 140%;
    color: #383838;
    transition: all 0.3s ease;
    text-align: center;
    white-space: pre-wrap;
`

export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
`

export const ButtonWrapper = styled.div`
    transform: ${({ $expanded }) => $expanded ? 'rotate(90deg)' : 'rotate(270deg)'};
    transition: all 0.3s ease;
`

export const SectionContainer = styled.div`
    display: flex;
    flex-direction: column;
`

export const Badge = styled.div`
    background-color: ${({ $recommendation }) => {
        switch ($recommendation) {
            case 'suspeito':
                return '#f77b2144';
            case 'falso positivo':
                return '#0b1f8244';
            case 'suspeito crítico (em caso de bloqueio)':
                return '#ff828244';
            default:
                return 'transparent';
        }
    }};
    color: ${({ $recommendation }) => {
        switch ($recommendation) {
            case 'suspeito':
                return '#f54b02';
            case 'falso positivo':
                return '#0b1f82';
            case 'suspeito crítico (em caso de bloqueio)':
                return '#ff8282';
            default:
                return 'transparent';
        }
    }};
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 13px;
    letter-spacing: 0.5px;
    font-weight: bold;
`

export const FooterWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 16px;
    width: 100%;
`

export const UserMessageWrapper = styled.div`
    background-color: #f0f0f0;
    padding: 8px 16px;
    border-radius: 16px 0 16px 16px;
    max-width: 80%;
    width: fit-content;
`

export const UserPromptWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    background-color: #fafafa;
    border: 1px solid #dcdcdc;
    padding: 8px;
    border-radius: 4px;
    align-items: flex-end;
`